<template>
    <BackofficeLayout :title="$t('message.qualifiedApplicants.header')">
        <QualifiedApplicant />
    </BackofficeLayout>
</template>

<script>
import BackofficeLayout from "@/components/common/BackofficeLayout";
import QualifiedApplicant from "@/components/admin/Candidates/QualifiedApplicant";
export default {
    components: {
        BackofficeLayout,
        QualifiedApplicant,
    },
};
</script>

<style></style>
